import { CircularProgress, Fade, IconButton, Typography } from "@mui/material";
import * as s from "./styles";
import { useHistory, useParams } from "react-router-dom";
import { useBanners, useNotification } from "../../contexts";
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import { Button } from "../../components";
import { useCallback, useEffect } from "react";

const Banner = () => {
  const { handleNotification } = useNotification();
  const history = useHistory();
  const { bannerId } = useParams<{ bannerId?: string }>();
  const { loadingBanners, banners } = useBanners();

  const banner = banners.find((b) => b.bannerId === bannerId);

  const copyToClipboard = useCallback(() => {
    const text = banner?.link || window.location.href;
    const inputElement = document.createElement("textarea");
    inputElement.value = text;
    document.body.appendChild(inputElement);
    inputElement.select();
    document.execCommand("copy");
    document.body.removeChild(inputElement);
    handleNotification("success", "Link copiado para a área de transferência");
  }, [banner?.link, handleNotification]);

  useEffect(() => {
    if (banner === undefined && !loadingBanners) {
      history.push("/");
      handleNotification("error", "Banner não encontrado!");
    }
  }, [banner, handleNotification, history, loadingBanners]);

  if (loadingBanners)
    return (
      <s.BannerContainer>
        <CircularProgress sx={{ margin: "auto" }} />
      </s.BannerContainer>
    );

  return (
    <Fade in timeout={1000}>
      <s.BannerContainer>
        <s.BannerHeader>
          <IconButton size="large" onClick={() => history.goBack()}>
            <ArrowBack />
          </IconButton>
          <Typography fontSize={28} fontWeight={500}>
            Detalhes do evento
          </Typography>
        </s.BannerHeader>
        <s.BannerImage src={banner?.imageUrl} alt={banner?.title} />
        <s.ShareContainer>
          <Typography
            variant="body1"
            fontWeight={500}
            color="primary.contrastText"
          >
            Envie para seus amigos:
          </Typography>
          <Button
            size="small"
            variant="contained"
            sx={{ fontWeight: 700 }}
            onClick={copyToClipboard}
          >
            COMPARTILHAR
          </Button>
        </s.ShareContainer>
        <s.BannerTitle variant="h3">{banner?.title}</s.BannerTitle>
        <s.BannerDescription color="primary.contrastText">
          {banner?.message}
        </s.BannerDescription>
        <s.BuyButton
          variant="contained"
          onClick={() => window.open(banner?.link, "_blank")}
        >
          QUERO APROVEITAR
          <div>
            <ArrowForward />
          </div>
        </s.BuyButton>
      </s.BannerContainer>
    </Fade>
  );
};

export default Banner;
